import { Badge } from "@mui/material";
import { img_300 } from "../config/config"
import TransitionsModal from "../ContentModal/ContentModal";
import { unavailable } from './../config/config';
import "./SingleContent.css"
export const SingleContent = ({ output }) => {
    return (
        <>
            {console.log(output.media_type)}
            <TransitionsModal media_type={output.media_type} id={output.id}>
                <Badge badgeContent={output.vote_average} color={output.vote_average > 7.2 ? "primary" : "secondary"} />
                <img className="poster" src={output.poster_path ? `${img_300}/${output.poster_path}` : unavailable} alt={output.title || output.name} />
                <b className="title">{output.title || output.name}</b>
                <span className="subtitle">{output.media_type}</span>
                <span className="subtitle"> {output.release_date || output.first_air_date}</span>
            </TransitionsModal>
        </>

    )
}